module.exports = __webpack_public_path__ + "img/skrill_big.7dc6ae76.png";